import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';

const GetMannequins = (params: any) =>
    request({
        url: ApiURL.Query.StudioQueryURLs.MannequinQueryURL.GetMannequins,
        method: RequestType.GET,
        params,
    });

const GetMannequinById = (id: number) =>
    request({
        url: ApiURL.Query.StudioQueryURLs.MannequinQueryURL.GetMannequinById + '/' + id,
        method: RequestType.GET,
    });

export const MannequinQuery = {
    GetMannequins,
    GetMannequinById,
};

